import React from 'react';
import styled from 'styled-components';
import { ButtonOutlined } from 'components/Shared';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon/Icon';
import FlexBox from '../Container/FlexBox';
const Container = styled.div `
  width: 100%;
`;
const Title = styled.h4 `
  font-size: 16px !important;
  letter-spacing: 1px !important;
  text-transform: uppercase !important;
  font-weight: 300 !important;
  color: ${({ theme }) => theme.palette.grey[700]} !important;
  margin-bottom: 0px !important;
`;
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  min-height: 38px;
  gap: 16px;
`;
const PreviewedList = ({ title, iconName, children, onSeeAllClick, className, }) => {
    const { t } = useTranslation();
    return (React.createElement(Container, { className: className },
        React.createElement(Header, null,
            React.createElement(FlexBox, { gap: 1 },
                iconName && React.createElement(Icon, { name: iconName, size: "x-large" }),
                React.createElement(Title, null, title)),
            onSeeAllClick && (React.createElement(ButtonOutlined, { size: "small", onClick: onSeeAllClick }, t('tracing.see-all')))),
        children));
};
export default PreviewedList;
